<template>
	<div class="drawer">
		<el-drawer size="433px" title="用户信息" :visible.sync="drawerStatus" @close='close' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" >
			<el-form style="padding:10px 36px 0 0px;">
				<el-form-item label="会员名称：" :label-width="formLabelWidth" prop="nick_name">
					<el-input v-model="form.nick_name" placeholder="请输入顾客昵称" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="性别：" :label-width="formLabelWidth" prop="sex">
					<el-radio-group v-model="form.sex" size="mini">
						<el-radio :label="'男'">男</el-radio>
						<el-radio :label="'女'">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号：" :label-width="formLabelWidth" prop="user_mobile">
					<el-input v-model="form.user_mobile" placeholder="请输入手机号" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="邮箱：" :label-width="formLabelWidth" prop="user_email">
					<el-input v-model="form.user_email" placeholder="请输入邮箱" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="生日：" :label-width="formLabelWidth" prop="sex">
					<el-date-picker style="width:208px;" v-model="datePickerValue" size="mini" :picker-options="{disabledDate(time) {return new Date().getTime() < time.getTime()}}" type="date" placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="家庭住址：" :label-width="formLabelWidth" prop="user_address">
					<el-input type="textarea" v-model="form.home_address" placeholder="请输入家庭住址" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="紧急联系人：" :label-width="formLabelWidth" >
					<el-input v-model="form.urgent_user" placeholder="请输入紧急联系人" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="紧急电话：" :label-width="formLabelWidth" >
					<el-input v-model="form.urgent_user_mobile" placeholder="请输入紧急电话" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="会员备注：" :label-width="formLabelWidth" >
					<el-input v-model="form.remark" placeholder="请输入备注" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '110px',
				datePickerValue:'',
				userDetail:{},
				form:{
					"id": '',
					"user_mobile": '',
					"nick_name": '',
					"avatar_pic": '',
					"user_email": '',
					"user_address": '',
					"home_address": '',
					"sex": '',
					user_type: '',
					urgent_user: '',
					urgent_user_mobile: '',
					remark:'',
				},
			}
		},
		props:{
			id:{
				default:''
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true;
			})
			this.getDetail()
		},
		methods: {
			close(){
				this.$emit("submit")
			},
			// 保存基本信息
			submit() {
				if(!this.$public.isTel(this.form.user_mobile)){
					this.$message({
						message: '手机号输入有误',
						type: 'error'
					});
					return 
				}
				let params = {
					"id": this.form.id,
					"user_mobile": this.form.user_mobile,
					"nick_name": this.form.nick_name,
					"avatar_pic": this.form.avatar_pic,
					"user_email": this.form.user_email,
					"user_address": this.form.user_address,
					"home_address": this.form.home_address,
					"sex": this.form.sex,
					birthday: this.$public.FTimeStr10(this.datePickerValue),
					user_type: this.form.user_type,
					urgent_user: this.form.urgent_user,
					urgent_user_mobile: this.form.urgent_user_mobile,
					remark: this.form.remark,
				}
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/member/update', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.$emit("submit",{type:'success',data:''})
					}
				})
			},
			getDetail(){
				let params = {
					id:this.id
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_member+'/api/middleware/member/Single', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.userDetail = res.data
						if(!this.$public.isNull(this.userDetail.basic_info.birthday)){
							this.datePickerValue = new Date(this.userDetail.basic_info.birthday*1000)
						}else{
							this.datePickerValue = ''
						}
						this.form = {
							"id": this.userDetail._id,
							"user_mobile": this.userDetail.basic_info.user_mobile,
							"nick_name": this.userDetail.basic_info.nick_name,
							"avatar_pic": this.userDetail.basic_info.avatar_pic,
							"user_email": this.userDetail.basic_info.user_email,
							"user_address": this.userDetail.basic_info.user_address,
							"home_address": this.userDetail.basic_info.home_address,
							"sex": this.userDetail.basic_info.sex,
							user_type: this.userDetail.basic_info.user_type,
							urgent_user: this.userDetail.basic_info.urgent_user,
							urgent_user_mobile: this.userDetail.basic_info.urgent_user_mobile,
							remark: this.userDetail.basic_info.remark,
						}
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: #3569FF;
				}
			}
		}
	}
	
</style>
